import { render, staticRenderFns } from "./VehicleBrand.vue?vue&type=template&id=ccf88a36&"
import script from "./VehicleBrand.vue?vue&type=script&lang=js&"
export * from "./VehicleBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports